import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ============ ENSEIGNES (Clients/Marques) ============
export const getEnseignes = () => axios.get(`${API}/enseignes`);
export const getEnseigne = (id) => axios.get(`${API}/enseignes/${id}`);
export const createEnseigne = (data) => axios.post(`${API}/enseignes`, data);
export const updateEnseigne = (id, data) => axios.put(`${API}/enseignes/${id}`, data);
export const deleteEnseigne = (id) => axios.delete(`${API}/enseignes/${id}`);
export const getEnseigneProjets = (enseigneId) => axios.get(`${API}/enseignes/${enseigneId}/projets`);
export const getEnseigneMagasins = (enseigneId) => axios.get(`${API}/enseignes/${enseigneId}/magasins`);
export const getProjetMagasinHistorique = (projetId) => axios.get(`${API}/projets/${projetId}/magasin-historique`);
export const getEnseignesProjetsMap = () => axios.get(`${API}/enseignes/projets-map`);
export const getNotificationSettings = () => axios.get(`${API}/auth/notification-settings`);
export const updateNotificationSettings = (data) => axios.put(`${API}/auth/notification-settings`, data);
export const uploadEnseigneLogo = (enseigneId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/enseignes/${enseigneId}/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Legacy compatibility
export const getClients = () => axios.get(`${API}/enseignes`);
export const getClient = (id) => axios.get(`${API}/enseignes/${id}`);
export const createClient = (data) => axios.post(`${API}/enseignes`, data);
export const updateClient = (id, data) => axios.put(`${API}/enseignes/${id}`, data);
export const deleteClient = (id) => axios.delete(`${API}/enseignes/${id}`);

// ============ PROJETS ============
export const getProjets = () => axios.get(`${API}/projets`);
export const getProjet = (id) => axios.get(`${API}/projets/${id}`);
export const createProjet = (data) => axios.post(`${API}/projets`, data);
export const updateProjet = (id, data) => axios.put(`${API}/projets/${id}`, data);
export const reorderProjets = (order) => axios.put(`${API}/projets/reorder`, { order });
export const deleteProjet = (id) => axios.delete(`${API}/projets/${id}`);
// Marge / Fournisseurs lots
export const getProjetMarge = (projetId) => axios.get(`${API}/projets/${projetId}/marge`);
export const setDevisReference = (projetId, devisReferenceIds) =>
  axios.put(`${API}/projets/${projetId}/devis-reference`, {
    devis_reference_ids: Array.isArray(devisReferenceIds) ? devisReferenceIds : (devisReferenceIds ? [devisReferenceIds] : [])
  });
export const createFournisseurLot = (projetId, data) => 
  axios.post(`${API}/projets/${projetId}/fournisseurs-lots`, data);
export const updateFournisseurLot = (projetId, fournisseurId, data) => 
  axios.put(`${API}/projets/${projetId}/fournisseurs-lots/${fournisseurId}`, data);
export const deleteFournisseurLot = (projetId, fournisseurId) => 
  axios.delete(`${API}/projets/${projetId}/fournisseurs-lots/${fournisseurId}`);
export const uploadDevisFournisseur = (projetId, fournisseurId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/projets/${projetId}/fournisseurs-lots/${fournisseurId}/upload-devis`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const getDevisFournisseurPdfUrl = (projetId, fournisseurId) => 
  `${API}/projets/${projetId}/fournisseurs-lots/${fournisseurId}/devis-pdf`;

// Download devis fournisseur PDF with authentication
export const downloadDevisFournisseurPdf = async (projetId, fournisseurId, entreprise) => {
  const response = await axios.get(`${API}/projets/${projetId}/fournisseurs-lots/${fournisseurId}/devis-pdf`, {
    responseType: 'blob'
  });
  
  // Create download link
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `Devis_${entreprise || 'fournisseur'}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Analyze devis fournisseur with AI
export const analyzeDevisFournisseur = (projetId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/projets/${projetId}/analyze-devis-fournisseur`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const createFournisseurFromAnalysis = (projetId, data) => {
  const formData = new FormData();
  formData.append('lot_id', data.lot_id);
  formData.append('entreprise', data.entreprise);
  formData.append('montant_ht', data.montant_ht);
  formData.append('temp_filename', data.temp_filename);
  formData.append('slot', data.slot || 1);
  formData.append('reference_devis', data.reference_devis || '');
  formData.append('date_devis', data.date_devis || '');
  return axios.post(`${API}/projets/${projetId}/create-fournisseur-from-analysis`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Bons de commande
export const getProjetBDC = (projetId) => axios.get(`${API}/projets/${projetId}/bdc`);
export const genererBDC = (projetId, fournisseurId, options = {}) => 
  axios.post(`${API}/projets/${projetId}/fournisseurs-lots/${fournisseurId}/generer-bdc`, null, {
    params: { auto_liquidation: !!options.auto_liquidation },
  });
export const proposeBDCType = (projetId, fournisseurId) =>
  axios.post(`${API}/projets/${projetId}/fournisseurs-lots/${fournisseurId}/propose-bdc-type`);

// Facture matching / cleanup
export const unlinkFactureFromSlot = (factureId) =>
  axios.post(`${API}/factures-artisans/${factureId}/unlink`);
export const reassignFacture = (factureId, payload) =>
  axios.patch(`${API}/factures-artisans/${factureId}/reassign`, payload);
export const detectMargeDuplicates = (projetId) =>
  axios.get(`${API}/projets/${projetId}/marge-duplicates`);
export const mergeFournisseurSlots = (projetId, keepSlotId, discardSlotId) =>
  axios.post(`${API}/projets/${projetId}/fournisseurs-lots/merge`, {
    keep_slot_id: keepSlotId,
    discard_slot_id: discardSlotId,
  });
export const getBDCPdfUrl = (projetId, bdcId) => `${API}/projets/${projetId}/bdc/${bdcId}/pdf`;
export const getBDCPdfSigneUrl = (projetId, bdcId) => `${API}/projets/${projetId}/bdc/${bdcId}/pdf-signe`;
export const signerBDC = (projetId, bdcId, data) => axios.post(`${API}/projets/${projetId}/bdc/${bdcId}/signer`, data);

// Download BDC PDF with authentication
export const downloadBDCPdf = async (projetId, bdcId, isSigned, numero) => {
  const endpoint = isSigned ? 'pdf-signe' : 'pdf';
  const response = await axios.get(`${API}/projets/${projetId}/bdc/${bdcId}/${endpoint}`, {
    responseType: 'blob'
  });
  
  // Create download link
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const suffix = isSigned ? '_SIGNE' : '';
  link.setAttribute('download', `BDC_${numero.replace(/-/g, '_')}${suffix}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Legacy - keep for backward compatibility
export const updateCoutLot = (projetId, lotId, data) => 
  axios.put(`${API}/projets/${projetId}/couts-lots/${lotId}`, data);
export const uploadDevisLot = (projetId, lotId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/projets/${projetId}/couts-lots/${lotId}/upload-devis`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const addDevisTypeToProjet = (projetId, typeCode) => 
  axios.post(`${API}/projets/${projetId}/add-devis-type/${typeCode}`);
export const getAvailableDevisTypes = (projetId) => 
  axios.get(`${API}/projets/${projetId}/available-devis-types`);
export const resyncProjetFromBase = (projetId) => 
  axios.post(`${API}/projets/${projetId}/resync-from-base`);
export const resyncDevisFromBase = (projetId, devisId) => 
  axios.post(`${API}/projets/${projetId}/resync-devis/${devisId}`);

// ============ DEVIS MAAG ============
export const getDevisMaag = () => axios.get(`${API}/devis-maag`);
export const getDevisMaagById = (id) => axios.get(`${API}/devis-maag/${id}`);
export const getProjetDevisMaag = (projetId) => axios.get(`${API}/projets/${projetId}/devis-maag`);
export const createDevisMaag = (data) => axios.post(`${API}/devis-maag`, data);
export const updateDevisMaag = (id, data) => axios.put(`${API}/devis-maag/${id}`, data);
export const deleteDevisMaag = (id) => axios.delete(`${API}/devis-maag/${id}`);
export const duplicateDevisMaag = (data) => axios.post(`${API}/devis-maag/duplicate`, data);
export const getDevisAvailableForCopy = (enseigneId = null) => {
  const params = enseigneId ? `?enseigne_id=${enseigneId}` : '';
  return axios.get(`${API}/devis-maag/available-for-copy${params}`);
};
export const generateSignatureLink = (devisId, data = {}) => 
  axios.post(`${API}/devis-maag/${devisId}/generate-signature-link`, data);

// Public API (no auth)
export const getPublicDevis = (token) => 
  axios.get(`${API}/public/devis/${token}`);
export const signPublicDevis = (token, data) => 
  axios.post(`${API}/public/devis/${token}/signer`, data);
export const getPublicSignedPdfUrl = (devisId) => 
  `${API}/public/devis/${devisId}/pdf`;

// Duplicate devis for V2 (after signature)
export const duplicateDevisForV2 = (devisId) => 
  axios.post(`${API}/devis-maag/${devisId}/duplicate-for-v2`);

// Legacy compatibility
export const getDevis = () => axios.get(`${API}/devis-maag`);
export const getDevisById = (id) => axios.get(`${API}/devis-maag/${id}`);
export const createDevis = (data) => axios.post(`${API}/devis-maag`, data);
export const updateDevis = (id, data) => axios.put(`${API}/devis-maag/${id}`, data);
export const addDevisLot = (devisId, nom) => axios.post(`${API}/devis-maag/${devisId}/lots`, { nom });
export const renameDevisLot = (devisId, lotId, nom) => axios.patch(`${API}/devis-maag/${devisId}/lots/${lotId}`, { nom });
export const deleteDevisLot = (devisId, lotId) => axios.delete(`${API}/devis-maag/${devisId}/lots/${lotId}`);
export const resetDevisLots = (devisId) => axios.post(`${API}/devis-maag/${devisId}/lots/reset`);
export const deleteDevis = (id) => axios.delete(`${API}/devis-maag/${id}`);
export const getClientDevis = (clientId) => axios.get(`${API}/enseignes/${clientId}/projets`);

// ============ LOTS ============
export const getLots = () => axios.get(`${API}/lots`);

// ============ TITRES DEVIS ============
export const getTitresDevis = () => axios.get(`${API}/titres-devis`);

// ============ POSTES ============
export const createPoste = (devisId, lotId, data) => 
  axios.post(`${API}/devis-maag/${devisId}/postes?lot_id=${lotId}`, data);
export const updatePoste = (posteId, data) => axios.put(`${API}/postes/${posteId}`, data);
export const deletePoste = (posteId) => axios.delete(`${API}/postes/${posteId}`);
export const clearLotPostes = (devisId, lotId) => axios.delete(`${API}/devis/${devisId}/lots/${lotId}/clear`);
export const bulkDeletePostes = (devisId, posteIds) => axios.delete(`${API}/devis/${devisId}/postes/bulk`, { data: posteIds });
export const createPosteWithEnrichment = (devisId, data) => axios.post(`${API}/devis-maag/${devisId}/postes-enriched`, data);

// ============ BASE FOURNISSEURS DIRECTS (defaults in Base MAAG) ============
export const getBaseFournisseursDirects = () => axios.get(`${API}/base-fournisseurs-directs`);
export const createBaseFournisseurDirect = (data) => axios.post(`${API}/base-fournisseurs-directs`, data);
export const updateBaseFournisseurDirect = (fdId, data) => axios.put(`${API}/base-fournisseurs-directs/${fdId}`, data);
export const deleteBaseFournisseurDirect = (fdId) => axios.delete(`${API}/base-fournisseurs-directs/${fdId}`);

// ============ ENSEIGNE FOURNISSEURS DIRECTS CONFIG ============
export const getEnseigneFournisseursDirectsConfig = (enseigneId) => axios.get(`${API}/enseignes/${enseigneId}/fournisseurs-directs-config`);
export const setEnseigneFournisseurDirectOverride = (enseigneId, data) => axios.post(`${API}/enseignes/${enseigneId}/fournisseurs-directs-config`, data);
export const deleteEnseigneFournisseurDirectOverride = (enseigneId, overrideId) => axios.delete(`${API}/enseignes/${enseigneId}/fournisseurs-directs-config/${overrideId}`);

// ============ FOURNISSEURS DIRECTS (payés par le client - project level) ============
export const getFournisseursDirects = (projetId) => axios.get(`${API}/projets/${projetId}/fournisseurs-directs`);
export const createFournisseurDirect = (data) => axios.post(`${API}/fournisseurs-directs`, data);
export const updateFournisseurDirect = (fdId, data) => axios.put(`${API}/fournisseurs-directs/${fdId}`, data);
export const deleteFournisseurDirect = (fdId) => axios.delete(`${API}/fournisseurs-directs/${fdId}`);
export const bulkDeleteFournisseursDirects = (ids) => axios.post(`${API}/fournisseurs-directs/bulk-delete`, { ids });

// ============ ACHATS ARTISANS (coûts MAAG) ============
export const getAchatsArtisans = (projetId) => axios.get(`${API}/projets/${projetId}/achats-artisans`);
export const createAchatArtisan = (data) => axios.post(`${API}/achats-artisans`, data);
export const updateAchatArtisan = (id, data) => axios.put(`${API}/achats-artisans/${id}`, data);
export const deleteAchatArtisan = (id) => axios.delete(`${API}/achats-artisans/${id}`);
export const analyzeDevisArtisan = (projetId, lotId, file) => {
  const formData = new FormData();
  formData.append('lot_id', lotId);
  formData.append('file', file);
  return axios.post(`${API}/projets/${projetId}/analyze-devis-artisan`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Legacy compatibility
export const getDevisAchats = (projetId) => axios.get(`${API}/projets/${projetId}/achats-artisans`);
export const createAchat = (data) => axios.post(`${API}/achats-artisans`, data);
export const updateAchat = (id, data) => axios.put(`${API}/achats-artisans/${id}`, data);
export const deleteAchat = (id) => axios.delete(`${API}/achats-artisans/${id}`);

// ============ SUIVI ARTISANS (Factures) ============
export const getSuiviArtisans = (projetId) => axios.get(`${API}/projets/${projetId}/suivi-artisans`);
export const createSuiviArtisan = (data) => axios.post(`${API}/suivi-artisans`, data);

// ============ FACTURES ARTISANS (PDF) ============
export const getFacturesArtisans = (projetId) => axios.get(`${API}/projets/${projetId}/factures-artisans`);
export const uploadFactureArtisan = (projetId, formData) => 
  axios.post(`${API}/projets/${projetId}/factures-artisans`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
export const analyzeInvoice = (formData) => 
  axios.post(`${API}/analyze-invoice`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000  // 2 minutes for Claude Vision
  });
export const updateFactureArtisan = (factureId, data) => axios.put(`${API}/factures-artisans/${factureId}`, data);
export const deleteFactureArtisan = (factureId) => axios.delete(`${API}/factures-artisans/${factureId}`);
export const getFactureDownloadUrl = (factureId) => {
  const token = localStorage.getItem('token');
  return `${API}/factures-artisans/${factureId}/download?token=${token}`;
};
export const getFacturesExportUrl = (projetId, statut = 'validee') => {
  const token = localStorage.getItem('token');
  return `${API}/projets/${projetId}/factures-artisans/export?token=${token}&statut=${statut}`;
};
export const getAllFacturesExportUrl = (statut = 'validee') => {
  const token = localStorage.getItem('token');
  return `${API}/factures-artisans/export-all?token=${token}&statut=${statut}`;
};

// ============ DASHBOARD ============
export const getDashboard = () => axios.get(`${API}/dashboard`);

// ============ MIGRATION ============
export const migrateData = () => axios.post(`${API}/migrate-data`);

// ============ PDF ============
export const getDevisPdf = (devisId) => {
  const token = localStorage.getItem('token');
  return axios.get(`${API}/devis-maag/${devisId}/pdf?token=${token}`, { responseType: 'blob' });
};

export const getDevisPdfUrl = (devisId) => {
  const token = localStorage.getItem('token');
  return `${API}/devis-maag/${devisId}/pdf?token=${token}`;
};

export const getBdcPdfUrl = (projetId, bdcId, isSigned = false) => {
  const token = localStorage.getItem('token');
  const endpoint = isSigned ? 'pdf-signe' : 'pdf';
  return `${API}/projets/${projetId}/bdc/${bdcId}/${endpoint}?token=${token}`;
};

export const deleteBdc = (projetId, bdcId) =>
  axios.delete(`${API}/projets/${projetId}/bdc/${bdcId}`);

export const getPlanningPdfUrl = (planningId) => {
  const token = localStorage.getItem('token');
  return `${API}/plannings/${planningId}/pdf?token=${token}`;
};

// ============ SIGNATURE ============
export const signerDevis = (devisId, signatureData) => 
  axios.post(`${API}/devis-maag/${devisId}/signer`, signatureData);

// Legacy
export const getDevisSortie = (projetId) => axios.get(`${API}/projets/${projetId}/marge`);

// ============ FOURNISSEURS (ancienne structure) ============
export const getFournisseurs = () => axios.get(`${API}/fournisseurs`);
export const createFournisseur = (data) => axios.post(`${API}/fournisseurs`, data);
export const deleteFournisseur = (id) => axios.delete(`${API}/fournisseurs/${id}`);

// ============ BASE MAAG (Descriptifs) ============
export const getBaseMaag = () => axios.get(`${API}/base-maag`);
export const getBaseMaagFlat = (enseigneId) => axios.get(`${API}/base-maag/flat${enseigneId ? `?enseigne_id=${enseigneId}` : ''}`);
export const createBaseMaagPrestation = (data) => axios.post(`${API}/base-maag`, data);
export const updateBaseMaagPrestation = (id, data) => axios.put(`${API}/base-maag/${id}`, data);
export const deleteBaseMaagPrestation = (id) => axios.delete(`${API}/base-maag/${id}`);

// ============ SOUS-LOTS ============
export const getSousLots = () => axios.get(`${API}/sous-lots`);
export const getSousLotsByLot = (lotId) => axios.get(`${API}/lots/${lotId}/sous-lots`);
export const createSousLot = (data) => axios.post(`${API}/sous-lots`, data);
export const updateSousLot = (id, data) => axios.put(`${API}/sous-lots/${id}`, data);
export const deleteSousLot = (id) => axios.delete(`${API}/sous-lots/${id}`);

// ============ PLANNING TRAVAUX ============
export const getProjetPlannings = (projetId) => axios.get(`${API}/projets/${projetId}/plannings`);
export const getPlanning = (planningId) => axios.get(`${API}/plannings/${planningId}`);
export const createPlanning = (projetId) => axios.post(`${API}/projets/${projetId}/plannings`);
export const updatePlanning = (planningId, data) => axios.put(`${API}/plannings/${planningId}`, data);
export const deletePlanning = (planningId) => axios.delete(`${API}/plannings/${planningId}`);
export const duplicatePlanning = (planningId) => axios.post(`${API}/plannings/${planningId}/duplicate`);
export const resyncPlanning = (planningId) => axios.post(`${API}/plannings/${planningId}/resync`);

// ============ PRIX PAR ENSEIGNE ============
export const getEnseignePrix = (enseigneId) => axios.get(`${API}/enseignes/${enseigneId}/prix`);
export const setEnseignePrix = (enseigneId, data) => axios.post(`${API}/enseignes/${enseigneId}/prix`, data);
export const setEnseignePrixBatch = (enseigneId, prixList) => axios.put(`${API}/enseignes/${enseigneId}/prix/batch`, prixList);
export const deleteEnseignePrix = (enseigneId, prestationCode) => axios.delete(`${API}/enseignes/${enseigneId}/prix/${prestationCode}`);

// ============ DEVIS TYPES PAR ENSEIGNE ============
export const getEnseigneDevisTypes = (enseigneId) => axios.get(`${API}/enseignes/${enseigneId}/devis-types`);
export const getDevisTypeDetails = (devisTypeId) => axios.get(`${API}/devis-types/${devisTypeId}`);
export const getDevisTypeLignes = (devisTypeId) => axios.get(`${API}/devis-types/${devisTypeId}/lignes`);
export const updateDevisTypeLigne = (devisTypeId, ligneId, data) => axios.put(`${API}/devis-types/${devisTypeId}/lignes/${ligneId}`, data);
export const toggleLotInDevisType = (devisTypeId, lotId, actif) => axios.put(`${API}/devis-types/${devisTypeId}/lots/${lotId}/toggle?actif=${actif}`);

// ============ DEVIS TYPES GLOBAUX (BASE MAAG) ============
export const getDevisTypesGlobal = () => axios.get(`${API}/devis-types-global`);
export const toggleLotInDevisTypeGlobal = (typeCode, lotId, actif) => axios.put(`${API}/devis-types-global/${typeCode}/lots/${lotId}/toggle?actif=${actif}`);

// Prestations dans Devis Types Globaux
export const getDevisTypeGlobalPrestations = (typeCode) => axios.get(`${API}/devis-types-global/${typeCode}/prestations`);
export const togglePrestationInDevisTypeGlobal = (typeCode, prestationId, actif) => 
  axios.put(`${API}/devis-types-global/${typeCode}/prestations/${prestationId}/toggle?actif=${actif}`);
export const updatePrestationInDevisTypeGlobal = (typeCode, prestationId, data) => 
  axios.put(`${API}/devis-types-global/${typeCode}/prestations/${prestationId}`, data);
export const addPrestationToDevisTypeGlobal = (typeCode, prestationId) => 
  axios.post(`${API}/devis-types-global/${typeCode}/prestations/${prestationId}/add`);
export const removePrestationFromDevisTypeGlobal = (typeCode, prestationId) => 
  axios.delete(`${API}/devis-types-global/${typeCode}/prestations/${prestationId}`);

// ============ FOURNISSEURS MAAG - GESTION CENTRALISÉE ============

// Catégories disponibles
export const getCategoriesFactures = () => axios.get(`${API}/fournisseurs/categories`);

// Analyse IA facture entreprise
export const analyzeInvoiceEntreprise = (formData) => axios.post(`${API}/analyze-invoice-entreprise`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
  timeout: 120000  // 2 minutes for Claude Vision
});

// Factures entreprise (non liées à un projet)
export const getFacturesEntreprise = () => axios.get(`${API}/fournisseurs/factures-entreprise`);
export const uploadFactureEntreprise = (formData) => axios.post(`${API}/fournisseurs/factures-entreprise`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const updateFactureEntreprise = (id, data) => axios.put(`${API}/fournisseurs/factures-entreprise/${id}`, data);
export const deleteFactureEntreprise = (id) => axios.delete(`${API}/fournisseurs/factures-entreprise/${id}`);
export const getFactureEntrepriseDownloadUrl = (id) => {
  const token = localStorage.getItem('token');
  return `${API}/fournisseurs/factures-entreprise/${id}/download?token=${token}`;
};

// Factures à payer (toutes sources confondues)
export const getFacturesAPayer = () => axios.get(`${API}/fournisseurs/a-payer`);

// Archives mensuelles
export const getArchivesMensuelles = () => axios.get(`${API}/fournisseurs/archives`);
export const getArchiveExportUrl = (year, month) => {
  const token = localStorage.getItem('token');
  return `${API}/fournisseurs/archives/${year}/${month}/export?token=${token}`;
};

// Marquer une facture comme payée
export const marquerFacturePayee = (type, id) => axios.put(`${API}/fournisseurs/payer/${type}/${id}`);

// ============ ADMIN / SERVER PATH ============
export const getSuggestedServerPath = (projetId) => axios.get(`${API}/admin/generate-suggested-path/${projetId}`);

// === Factures Client (Henrri PDFs) ===
export const listFacturesClient = (projetId) => axios.get(`${API}/projets/${projetId}/factures-client`);
export const uploadFactureClient = (projetId, formData) => axios.post(`${API}/projets/${projetId}/factures-client`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteFactureClient = (projetId, factureId) => axios.delete(`${API}/projets/${projetId}/factures-client/${factureId}`);
export const downloadFactureClientUrl = (factureId) => `${API}/factures-client/${factureId}/download?token=${localStorage.getItem('token')}`;

// === Frais Généraux (carte bancaire, restaurants, timbres, etc.) ===
export const listFraisGeneraux = (projetId) => axios.get(`${API}/projets/${projetId}/frais-generaux`);
export const createFraisGeneral = (projetId, data) => axios.post(`${API}/projets/${projetId}/frais-generaux`, data);
export const updateFraisGeneral = (projetId, fraisId, data) => axios.put(`${API}/projets/${projetId}/frais-generaux/${fraisId}`, data);
export const deleteFraisGeneral = (projetId, fraisId) => axios.delete(`${API}/projets/${projetId}/frais-generaux/${fraisId}`);

// ============ DESCRIPTIF ARTISANS (Demande de Devis) ============
export const getDescriptifArtisans = (projetId) => axios.get(`${API}/projets/${projetId}/descriptif-artisans`);
export const createDescriptifArtisans = (projetId, data) => axios.post(`${API}/projets/${projetId}/descriptif-artisans`, data);
export const updateDescriptifArtisans = (projetId, data) => axios.put(`${API}/projets/${projetId}/descriptif-artisans`, data);
export const resyncDescriptifArtisans = (projetId, devisSourceId = null) =>
  axios.post(`${API}/projets/${projetId}/descriptif-artisans/resync`, devisSourceId ? { devis_source_id: devisSourceId } : {});
export const deleteDescriptifArtisans = (projetId) => axios.delete(`${API}/projets/${projetId}/descriptif-artisans`);

// Descriptif Artisans Lines
export const addDescriptifLigne = (projetId, data) => axios.post(`${API}/projets/${projetId}/descriptif-artisans/lignes`, data);
export const updateDescriptifLigne = (projetId, ligneId, data) => axios.put(`${API}/projets/${projetId}/descriptif-artisans/lignes/${ligneId}`, data);
export const deleteDescriptifLigne = (projetId, ligneId) => axios.delete(`${API}/projets/${projetId}/descriptif-artisans/lignes/${ligneId}`);

// Descriptif Artisans Export
export const getDescriptifPdfUrl = (projetId, lots = 'all') => {
  const token = localStorage.getItem('token');
  return `${API}/projets/${projetId}/descriptif-artisans/export/pdf?lots=${lots}&token=${token}`;
};
export const getDescriptifExcelUrl = (projetId, lots = 'all') => {
  const token = localStorage.getItem('token');
  return `${API}/projets/${projetId}/descriptif-artisans/export/excel?lots=${lots}&token=${token}`;
};

// Download descriptif PDF with authentication
export const downloadDescriptifPdf = async (projetId, lots = 'all', filename = 'Demande_Devis') => {
  const response = await axios.get(`${API}/projets/${projetId}/descriptif-artisans/export/pdf?lots=${lots}`, {
    responseType: 'blob'
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Download descriptif Excel with authentication
export const downloadDescriptifExcel = async (projetId, lots = 'all', filename = 'Demande_Devis') => {
  const response = await axios.get(`${API}/projets/${projetId}/descriptif-artisans/export/excel?lots=${lots}`, {
    responseType: 'blob'
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Descriptif Artisans Email
export const getDescriptifEmailTemplate = (projetId, prenomArtisan, modeTutoiement, lots) => 
  axios.get(`${API}/projets/${projetId}/descriptif-artisans/email-template`, {
    params: { prenom_artisan: prenomArtisan, mode_tutoiement: modeTutoiement, lots }
  });

export const sendDescriptifEmail = async (projetId, formData) => {
  return axios.post(`${API}/projets/${projetId}/descriptif-artisans/send-email`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getDescriptifEmailHistory = (projetId) => 
  axios.get(`${API}/projets/${projetId}/descriptif-artisans/email-history`);


// ============ CONTACTS (Carnet d'adresses) ============
export const getContacts = (typeContact, search, page = 1, limit = 50, favori = null, corpsMetier = null, region = null) => {
  const params = new URLSearchParams();
  if (typeContact) params.append('type_contact', typeContact);
  if (search) params.append('search', search);
  if (favori !== null) params.append('favori', favori);
  if (corpsMetier) params.append('corps_metier', corpsMetier);
  if (region) params.append('region', region);
  params.append('page', page);
  params.append('limit', limit);
  return axios.get(`${API}/contacts?${params.toString()}`);
};
export const getContact = (id) => axios.get(`${API}/contacts/${id}`);
export const createContact = (data) => axios.post(`${API}/contacts`, data);
export const updateContact = (id, data) => axios.put(`${API}/contacts/${id}`, data);
export const deleteContact = (id) => axios.delete(`${API}/contacts/${id}`);
export const bulkDeleteContacts = (ids) => axios.post(`${API}/contacts/bulk-delete`, { ids });
export const toggleFavori = (id) => axios.post(`${API}/contacts/${id}/toggle-favori`);
export const bulkToggleFavori = (ids, favori) => axios.post(`${API}/contacts/bulk-toggle-favori`, { ids, favori });
export const exportContactsCSV = () => axios.get(`${API}/contacts/export/csv`, { responseType: 'blob' });
export const importContactsCSV = (formData) => axios.post(`${API}/contacts/import/csv`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// ============ USER SIGNATURE ============
export const getUserSignature = () => axios.get(`${API}/auth/me/signature`);
export const updateUserSignature = (signatureBase64) => 
  axios.put(`${API}/auth/me/signature`, { signature_base64: signatureBase64 });

// ============ MOVE FOURNISSEUR ============
export const moveFournisseur = (achatId, newLotId) => 
  axios.put(`${API}/achats-artisans/${achatId}/move`, { new_lot_id: newLotId });
export const moveFournisseurLot = (projetId, fournisseurId, newLotId) =>
  axios.put(`${API}/projets/${projetId}/fournisseurs-lots/${fournisseurId}/move`, { new_lot_id: newLotId });

// ============ BDC EMAIL (Like Descriptif Artisans) ============
export const getBDCEmailTemplate = (projetId, bdcId, nomFournisseur, modeVouvoiement) => 
  axios.get(`${API}/projets/${projetId}/bdc/${bdcId}/email-template`, {
    params: { nom_fournisseur: nomFournisseur, mode_vouvoiement: modeVouvoiement }
  });
export const sendBDCEmail = (projetId, bdcId, data) => 
  axios.post(`${API}/projets/${projetId}/bdc/${bdcId}/send-email`, data);

// ============ PROJECT FILE MANAGER (SERVEUR MODULE) ============
export const getProjectFiles = (projetId) => axios.get(`${API}/projets/${projetId}/files`);
export const uploadProjectFile = (projetId, folderId, file, onProgress) => {
  const formData = new FormData();
  // Always pass the filename explicitly — works for File AND Blob (critical for iOS Safari fallback)
  const filename = file.name || 'upload.jpg';
  formData.append('file', file, filename);
  return axios.post(`${API}/projets/${projetId}/files/${folderId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress
  });
};
export const downloadProjectFile = (projetId, folderId, filename) => 
  axios.get(`${API}/projets/${projetId}/files/${folderId}/${encodeURIComponent(filename)}`, {
    responseType: 'blob'
  });
export const deleteProjectFile = (projetId, folderId, filename) => 
  axios.delete(`${API}/projets/${projetId}/files/${folderId}/${encodeURIComponent(filename)}`);
export const downloadProjectZip = (projetId) => 
  axios.get(`${API}/projets/${projetId}/files/download-zip`, { responseType: 'blob' });
export const createProjectSubfolder = (projetId, parentFolderId, subfolderName) =>
  axios.post(`${API}/projets/${projetId}/files/${parentFolderId}/subfolder`, { name: subfolderName });

// ============ FEEDBACK / MODIFICATIONS APP ============
export const uploadFeedbackScreenshot = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return axios.post(`${API}/feedback/screenshot`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const uploadFeedbackVideo = (file, onUploadProgress) => {
  const fd = new FormData();
  fd.append('file', file);
  return axios.post(`${API}/feedback/video`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
    timeout: 120000, // 2 min for large videos
  });
};
export const feedbackScreenshotUrl = (path) =>
  `${API}/feedback/screenshot/${path}?token=${localStorage.getItem('token')}`;

// ============ COMPTES-RENDUS DE CHANTIER ============
export const listComptesRendus = (projetId) => axios.get(`${API}/projets/${projetId}/comptes-rendus`);
export const createCompteRendu = (projetId, data) => axios.post(`${API}/projets/${projetId}/comptes-rendus`, data);
export const getCompteRendu = (crId) => axios.get(`${API}/comptes-rendus/${crId}`);
export const updateCompteRendu = (crId, data) => axios.patch(`${API}/comptes-rendus/${crId}`, data);
export const deleteCompteRendu = (crId) => axios.delete(`${API}/comptes-rendus/${crId}`);
export const uploadCRPhoto = (crId, file, onUploadProgress) => {
  const fd = new FormData();
  fd.append('file', file);
  return axios.post(`${API}/comptes-rendus/${crId}/photo`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });
};
export const crPhotoUrl = (path) =>
  `${API}/comptes-rendus/photo/${path}?token=${localStorage.getItem('token')}`;
export const crPdfUrl = (crId) =>
  `${API}/comptes-rendus/${crId}/pdf?token=${localStorage.getItem('token')}`;

export const feedbackVideoUrl = (path) =>
  `${API}/feedback/video/${path}?token=${localStorage.getItem('token')}`;
export const createFeedback = (data) => axios.post(`${API}/feedback`, data);
export const listFeedback = (statut, includeArchived = false) =>
  axios.get(`${API}/feedback`, {
    params: {
      ...(statut ? { statut } : {}),
      ...(includeArchived ? { include_archived: true } : {}),
    },
  });
export const updateFeedback = (id, data) => axios.patch(`${API}/feedback/${id}`, data);
export const deleteFeedback = (id) => axios.delete(`${API}/feedback/${id}`);
export const regenerateFeedbackPrompt = (id) =>
  axios.post(`${API}/feedback/${id}/regenerate-prompt`);
export const exportFeedbackUrl = (limit = 15, statut = 'valide', fmt = 'json', onlyUnexported = false, opts = {}) => {
  const params = new URLSearchParams({ limit: String(limit), statut, format: fmt });
  if (onlyUnexported) params.set('only_unexported', 'true');
  if (opts.dryRun) params.set('dry_run', 'true');
  if (opts.ids && opts.ids.length) params.set('ids', opts.ids.join(','));
  return `${API}/feedback/export?${params.toString()}`;
};


// ---- Frais (notes de frais & indemnités kilométriques) ----
export const getFraisStats = (mois) => axios.get(`${API}/frais/stats`, { params: { mois } });
export const getFraisVehicule = () => axios.get(`${API}/frais/vehicule`);
export const updateFraisVehicule = (data) => axios.put(`${API}/frais/vehicule`, data);
export const uploadCarteGrise = (formData) => axios.post(`${API}/frais/vehicule/carte-grise`, formData);
export const getFraisFichierUrl = (path) => `${API}/frais/fichier/${path}?token=${localStorage.getItem('token')}`;
export const analyserJustificatif = (formData) => axios.post(`${API}/frais/notes/analyser`, formData);
export const getFraisNotes = (mois) => axios.get(`${API}/frais/notes`, { params: { mois } });
export const createFraisNote = (data) => axios.post(`${API}/frais/notes`, data);
export const getFraisConvivesSuggestions = (projetId) => axios.get(`${API}/frais/projets/${projetId}/convives-suggestions`);
export const updateFraisNote = (id, data) => axios.patch(`${API}/frais/notes/${id}`, data);
export const deleteFraisNote = (id) => axios.delete(`${API}/frais/notes/${id}`);
export const calcDistanceTrajet = (depart, arrivee) => axios.post(`${API}/frais/trajets/distance`, { depart, arrivee });
export const getFraisTrajets = (mois) => axios.get(`${API}/frais/trajets`, { params: { mois } });
export const createFraisTrajet = (data) => axios.post(`${API}/frais/trajets`, data);
export const updateFraisTrajet = (id, data) => axios.patch(`${API}/frais/trajets/${id}`, data);
export const deleteFraisTrajet = (id) => axios.delete(`${API}/frais/trajets/${id}`);
export const getFraisARembourser = () => axios.get(`${API}/frais/a-rembourser`);
export const rembourserFrais = (noteIds, trajetIds) => axios.post(`${API}/frais/rembourser`, { note_ids: noteIds, trajet_ids: trajetIds });
export const getFraisExportPdfUrl = (mois) => `${API}/frais/export/${mois}/pdf?token=${localStorage.getItem('token')}`;
